import UTMGenerator from "./UTMGenerator";
  
  export default UTMGenerator;
  